module.exports = __webpack_public_path__ + "static/11-e67b4f08ca97874ab53c3a38e65fbcc1.jpg";